import { Fragment } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { getOccupancyString } from '../../../../../utils'
import messages from '../../translations'
import { PackageHeader } from '../PackageItems'
import { PriceConverter } from '../../../../helpers'

export const CabinInfoGuest = ({ item, currency, isCheckout }) => {
  const intl = useIntl()
  const messageType = item.isDiver
    ? messages.diverPlural
    : messages.nonDiverPlural
  const quantity = isCheckout ? item.qty : item.quantity
  const guestTitle = intl.formatMessage(messageType, {
    qty: quantity,
  })
  return (
    <span>
      {guestTitle}&nbsp;
      {isCheckout ? (
        <PriceConverter currency={currency} amount={item?.priceNet} />
      ) : (
        <PriceConverter
          currency={currency}
          amount={item?.priceWithoutTaxes + item?.singleSurcharge}
        />
      )}
    </span>
  )
}

export const BookingDetailsCardCabinInfo = ({
  cabin,
  number,
  currency,
  isSingleOccupancy,
}) => {
  const intl = useIntl()
  const { title, cabinSubtotal, taxAmount, items } = cabin
  return (
    <div className={`price-pan__body ${number > 1 ? 'no-border-top' : ''}`}>
      <div className='price-pan__body__row cabin-details'>
        <div className='item-row'>
          <div className='title bold'>
            {intl.formatMessage(messages.cabin)}&nbsp;{number}: &nbsp;
            {title}
          </div>
          <div className='total-price'>
            <span className='price'>
              <PriceConverter
                currency={currency}
                amount={cabinSubtotal - taxAmount}
              />
            </span>
          </div>
        </div>
        <div className='item-row'>
          <div className='cabin-info'>
            <ul>
              <li>
                <span className='bold'>
                  {intl.formatMessage(messages.guests)}:&nbsp;
                </span>
                <div>
                  {items.map((item, index) => (
                    <CabinInfoGuest
                      item={item}
                      key={`${title}${number}${index}`}
                      currency={currency}
                    />
                  ))}
                </div>
              </li>
              <li>
                <span className='bold'>
                  {intl.formatMessage(messages.occupancy)}:&nbsp;
                </span>
                <div>
                  {getOccupancyString(
                    cabin.divers + cabin.nonDivers,
                    isSingleOccupancy,
                  )}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

const CheckoutCabinDetails = ({
  currency,
  number,
  cabin,
  taxPercent,
  taxesAmount,
}) => {
  const intl = useIntl()
  const { title, cabinPrice, cabinComparePrice, items } = cabin
  const taxPrice = Math.ceil((cabinPrice * taxPercent) / 100)
  return (
    <div className={`price-pan__body ${number > 1 ? 'no-border-top' : ''}`}>
      <div className='price-pan__body__row cabin-details'>
        <div className='item-row'>
          <div className='title bold'>
            {intl.formatMessage(messages.cabin)}&nbsp;{number}: &nbsp;
            {title}
          </div>
          <div className='total-price'>
            <span className='price'>
              <PriceConverter currency={currency} amount={cabinPrice} />
            </span>
            {cabinComparePrice > cabinPrice && (
              <div>
                <span className='compare-price'>
                  <PriceConverter
                    currency={currency}
                    amount={cabinComparePrice}
                  />
                </span>
                <span className='saving'>
                  <FormattedMessage
                    id='saving'
                    defaultMessage='You are saving'
                  />
                </span>
              </div>
            )}
          </div>
        </div>
        <div className='item-row'>
          <div className='cabin-info'>
            <ul>
              <li>
                <span className='bold'>
                  {intl.formatMessage(messages.guests)}:&nbsp;
                </span>
                <div>
                  {items.map((item, index) => (
                    <CabinInfoGuest
                      item={item}
                      key={`${title}${number}${index}`}
                      currency={currency}
                      isCheckout
                    />
                  ))}
                </div>
              </li>
              <li>
                <span className='bold'>
                  {intl.formatMessage(messages.occupancy)}:&nbsp;
                </span>
                <div>{items[0]?.verbose}</div>
              </li>
            </ul>
          </div>
        </div>
        {taxPercent > 0 && (
          <Fragment>
            <div className='item-row tax-info'>
              <div className='title'>
                <FormattedMessage id='taxes' defaultMessage='Taxes' />{' '}
                {taxPercent}%
              </div>
              <div className='total-price'>
                <span className='price'>
                  <small>
                    <PriceConverter currency={currency} amount={taxPrice} />
                  </small>
                </span>
              </div>
            </div>
            <div className='item-row total-cabin-price'>
              <div className='title bold'>
                <FormattedMessage
                  id='total.price.for.cabin'
                  defaultMessage='Total price for Cabin {cabinNumber}'
                  values={{ cabinNumber: number }}
                />
              </div>
              <div className='total-price'>
                <span className='price'>
                  <PriceConverter
                    currency={currency}
                    amount={cabinPrice + taxPrice}
                  />
                </span>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  )
}

const BookingDetailsCardCabinsInfo = ({ order, currency, isCheckout }) => {
  const intl = useIntl()
  const { cabinOverview, taxPercent, taxesAmount } = order
  return (
    <Fragment>
      <PackageHeader title={intl.formatMessage(messages.bookingIncludes)} />
      {cabinOverview.map((cabin, index) =>
        isCheckout ? (
          <CheckoutCabinDetails
            key={cabin.title + index}
            cabin={cabin}
            number={index + 1}
            currency={currency}
            taxPercent={taxPercent}
          />
        ) : (
          <BookingDetailsCardCabinInfo
            key={cabin.title + index}
            cabin={cabin}
            number={index + 1}
            currency={currency}
            isSingleOccupancy={cabin.isSingleOccupancy}
          />
        ),
      )}
    </Fragment>
  )
}

export default BookingDetailsCardCabinsInfo
